module.exports = __webpack_public_path__ + "static/img/team-member-1.a5503acd.jpg";